/* announce-bar.js — announcement bar + language switcher.
   The switcher owns the site's text direction: picking Urdu or Arabic puts the
   document into RTL, which the [dir="rtl"] block in style.css mirrors.
   Generated by nothing — this file is hand-written, edit it directly. */
(function () {
  var RTL_LANGS = ['AR', 'UR'];
  var STORE = 'tlx-lang';
  var FONTS = {
    UR: 'https://fonts.googleapis.com/css2?family=Noto+Nastaliq+Urdu:wght@400;500;600;700&display=swap',
    AR: 'https://fonts.googleapis.com/css2?family=Noto+Naskh+Arabic:wght@400;500;600;700&display=swap'
  };

  function isRTL(code) { return RTL_LANGS.indexOf(code) > -1; }

  /* Pull the script's stylesheet in on demand, so an English visitor never pays
     for a font they cannot read. */
  function loadFont(code) {
    if (!FONTS[code] || document.getElementById('rtl-font')) return;
    var l = document.createElement('link');
    l.id = 'rtl-font';
    l.rel = 'stylesheet';
    l.href = FONTS[code];
    document.head.appendChild(l);
  }

  function apply(code, persist) {
    var d = document.documentElement;
    var rtl = isRTL(code);
    d.lang = code.toLowerCase();
    d.dir = rtl ? 'rtl' : 'ltr';
    d.classList.toggle('rtl', rtl);
    if (rtl) loadFont(code);
    if (persist) { try { localStorage.setItem(STORE, code); } catch (e) {} }

    /* keep every switcher on the page in step */
    document.querySelectorAll('.ann-switch').forEach(function (sw) {
      var label = sw.querySelector('.ann-label');
      if (label) label.textContent = code;
      sw.querySelectorAll('.ann-dropdown button').forEach(function (b) {
        b.classList.toggle('is-current', b.getAttribute('data-code') === code);
      });
    });

    document.dispatchEvent(new CustomEvent('languagechange', {
      detail: { code: code, rtl: rtl }
    }));
  }

  function current() {
    try { return localStorage.getItem(STORE) || 'EN'; } catch (e) { return 'EN'; }
  }

  document.querySelectorAll('.ann-switch').forEach(function (sw) {
    var dd = sw.querySelector('.ann-dropdown');
    if (!dd) return;
    sw.addEventListener('click', function (e) {
      var expanded = sw.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.ann-switch').forEach(function (o) {
        o.setAttribute('aria-expanded', 'false');
      });
      sw.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      e.stopPropagation();
    });
    sw.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        sw.click();
      } else if (e.key === 'Escape') {
        sw.setAttribute('aria-expanded', 'false');
      }
    });
    dd.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var code = btn.getAttribute('data-code');
        if (code) apply(code, true);
        sw.setAttribute('aria-expanded', 'false');
      });
    });
  });

  document.addEventListener('click', function () {
    document.querySelectorAll('.ann-switch').forEach(function (o) {
      o.setAttribute('aria-expanded', 'false');
    });
  });

  /* The inline head bootstrap has already set dir/lang to avoid a flash; this
     syncs the switcher UI and loads the font once the DOM exists. */
  apply(current(), false);
})();
